import {
  Chart,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
} from "chart.js";
import { DateTime } from "luxon";
import "chartjs-adapter-luxon";

const grainPrices = {
  domEl: null,

  init() {
    grainPrices.domEl = document.getElementById("grain-chart");
    if (grainPrices.domEl) {
      grainPrices.initChart();
    }
  },

  initChart() {
    Chart.register(
      LineController,
      LineElement,
      PointElement,
      LinearScale,
      TimeScale,
      Tooltip
    );

    const target = "wheat"; // TODO - get from data attribute

    const currData = grainPriceDataset[target];

    if (window.innerWidth < 768) {
      // Leave only last 7 items
      currData.splice(0, currData.length - 7);
    }

    let dynamicLayoutPadding = {
      top: 50,
      bottom: 30,
      left: 30,
      right: 30,
    };
    if (window.innerWidth < 768) {
      dynamicLayoutPadding = {
        top: 30,
        bottom: 20,
        left: 20,
        right: 20,
      };
    }

    const options = {
      type: "line",
      data: {
        datasets: [
          {
            label: translations.price,
            data: currData,
            fill: false,
            borderColor: "#F8A800",
            pointRadius: 6,
            pointHoverRadius: 10,
            pointBorderWidth: 0,
            pointHoverBorderWidth: 5,
            pointBorderColor: "#CCC",
            pointBackgroundColor: "#222720",
          },
        ],
      },
      options: {
        aspectRatio: window.innerWidth < 768 ? 1.5 : 2,
        interaction: {
          mode: "index",
          intersect: false,
        },
        scales: {
          x: {
            type: "time",
            offset: true,
            time: {
              isoWeekday: true,
              unit: "day",
              parser: function (value) {
                return DateTime.fromSeconds(value);
              },
            },
            border: {
              display: false,
            },
            grid: {
              display: false,
            },
            ticks: {
              maxRotation: 0,
              source: "data",
              callback: function (value, index, ticks) {
                const date = DateTime.fromMillis(value + 10, {
                  zone: "utc",
                  locale: document.documentElement.lang,
                });

                // check if monday
                if (date.weekday == 1) {
                  return (
                    date.toFormat("dd. ") +
                    translations.months[date.toFormat("MM")]
                  );
                }

                return "";
              },
            },
          },
          y: {
            type: "linear",
            border: {
              display: false,
              dash: [6, 6],
            },
            grace: "5%",
          },
        },
        layout: {
          padding: dynamicLayoutPadding,
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            displayColors: false,
            backgroundColor: "#fff",
            titleColor: "#222720",
            bodyColor: "#222720",
            borderColor: "#ccc",
            padding: 15,
            borderWidth: 1,
            cornerRadius: 2,
            xAlign: "center",
            yAlign: "bottom",
            caretPadding: 10,
            callbacks: {
              title: function (context) {
                return context[0].raw.title;
              },
              beforeLabel: function (context) {
                return context.raw.day;
              },
              label: function (context) {
                return context.dataset.label + ": " + context.raw.y + " €";
              },
            },
          },
        },
      },
    };

    const grainChart = new Chart(grainPrices.domEl, options);

    $(".change-grain-js").on("click", function (e) {
      const btnEl = $(this);
      const target = btnEl.data("target");

      // Nav handling
      $(".change-grain-js").attr("data-active", "false");
      btnEl.attr("data-active", "true");

      // Link handling
      $(".euronext-link").attr("data-active", "false");
      $(`.euronext-link[data-container="${target}"]`).attr(
        "data-active",
        "true"
      );

      // Table handling
      $(".grain-prices__table-wrap").attr("data-active", "false");
      $(`.grain-prices__table-wrap[data-container="${target}"]`).attr(
        "data-active",
        "true"
      );

      // Chart handling
      const currData = grainPriceDataset[target];

      grainChart.data.datasets[0].data = currData;

      grainChart.update();
    });
  },
};

export default grainPrices;
